<script setup lang="ts">
import { ToastViewport, type ToastViewportProps } from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';

import { cn } from '@/lib/utils';

const props = defineProps<
    ToastViewportProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props;

    return delegated;
});
</script>

<template>
    <ToastViewport
        v-bind="delegatedProps"
        :class="
            cn(
                'fixed z-[100] flex max-h-screen w-full flex-col-reverse p-4 bottom-4 left-4 sm:flex-col md:max-w-[420px]',
                props.class
            )
        "
    />
</template>
